import { HttpClient, HttpContext, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import "rxjs"; // adds ALL RxJS statics & operators to Observable
// See node_module/rxjs/Rxjs.js
// Import just the rxjs statics and operators we need for THIS app.
// Statics
// Operators
import {map, pluck, tap} from "rxjs/operators";
import { ContributoUnificato } from "src/app/common/models/contributo-unificato";
import { DannoBiologico } from "src/app/common/models/danno-biologico/danno-biologico";
import { DatiPignoramento } from "src/app/common/models/dati-pignoramento/dati-pignoramento";
import { IncassoSoggetto } from "src/app/common/models/incasso-soggetto";
import { ParcellaSoggetto } from "src/app/common/models/parcella-soggetto";
import { CensimentoDocumenti } from "src/app/common/models/sezioni/sezione-censimento-documenti/censimento-documenti";
import { SpeseDiGiudizio } from "src/app/common/models/sezioni/spese-giudizio";
import { TariffaLegale, TariffaLegaleIncaricato, } from "src/app/common/models/tariffa";
import {
  PraticaAmministrativaCreateAdapter
} from "../../amministrativa/pratica/models/pratica-amministrativa-create-adapter";
import {
  PraticaAutoritaIndipendenteCreateAdapter
} from "../../autorita-indipendente/pratica/models/pratica-autorita-indipendente-create-adapter";
import { PraticaCivileCreateAdapter } from "../../civile/pratica/models/pratica-civile-create-adapter";
import { RinvioAdapter } from "../../common/components/fascicolo/scadenzario-rinvio/rinvio-adapter";
import {
  SezioneEconomicaFondoOneriAdapter
} from "../../common/components/fascicolo/sezione-economica-fondo-oneri-update/sezione-economica-fondo-oneri-adapter";
import { RiunioneRequest } from "../../common/components/pratica/pratiche-riunite/riunione-request";
import { AltraParte } from "../../common/models/altraparte";
import { Anagrafica } from "../../common/models/anagrafica";
import { Atto } from "../../common/models/atto";
import { BeneMobile } from "../../common/models/bene-mobile/bene-mobile";
import { CalcoloInteressiRequest } from "../../common/models/calcolo-interessi-request";
import { Classificazione } from "../../common/models/classificazione";
import { Controparte } from "../../common/models/controparte";
import { DettaglioEsito } from "../../common/models/dettaglio-esito";
import { DocumentoAllegato } from "../../common/models/documento-allegato";
import { AggiornamentoClassificazioniRequest } from "../../common/models/dto/aggiornamento-classificazioni-request";
import { ArchiviaPraticaRequest } from "../../common/models/dto/archivia-pratica-request";
import {
  AssegnazioneGruppiTerritorialiRequest
} from "../../common/models/dto/assegnazione-gruppi-territoriali-request";
import { DatiGeneraliPraticaUpdateRequest } from "../../common/models/dto/dati-generali-pratica-update-request";
import { DefinisciFascicoloRequest } from "../../common/models/dto/definisci-fascicolo-request";
import { SezioneDatiGeneraliRequest } from "../../common/models/dto/sezione-dati-generali-request";
import { SezioneDatiGiudiziariRequest } from "../../common/models/dto/sezione-dati-giudiziari-request";
import { TemplatesProfiloRequest } from "../../common/models/dto/templates-profilo-request";
import { UpdateMetadatiDocumentoRequest } from "../../common/models/dto/update-metadati-documento-request";
import { UtenteProfiloRequest } from "../../common/models/dto/utente-profilo-request";
import { UtentiProfiloRequest } from "../../common/models/dto/utenti-profilo-request";
import { Esito } from "../../common/models/esito";
import { EsitoSpedizioneDiffida } from "../../common/models/esito-spedizione-diffida";
import { Fattura } from "../../common/models/fattura";
import { GruppoTerritoriale } from "../../common/models/gruppo-territoriale";
import { BenePignoratoImmobile } from "../../common/models/immobili/bene-pignorato-immobile";
import { Incasso } from "../../common/models/incasso";
import { Legale } from "../../common/models/legale";
import { LegaleIncaricato } from "../../common/models/legale-incaricato";
import { LetteraDiffida } from "../../common/models/lettera-diffida";
import { Liquidato } from "../../common/models/liquidato";
import { MiaRicerca } from "../../common/models/mia-ricerca";
import { Note } from "../../common/models/note";
import { Pagamento } from "../../common/models/pagamento";
import { ParcellaGiudiziale } from "../../common/models/parcella-giudiziale";
import { ParcellaStragiudiziale } from "../../common/models/parcella-stragiudiziale";
import { Petitum } from "../../common/models/petitum";
import { PetitumRevisione } from "../../common/models/petitum-revisione";
import { TemplateUtenteProfilo } from "../../common/models/profili-utente/template-utente-profilo";
import { ProvaScritta } from "../../common/models/prova-scritta";
import { Scadenza } from "../../common/models/scadenza";
import { AutoritaGiudiziaria } from "../../common/models/tipologiche/autorita-giudiziaria";
import { AutoritaGiudiziariaSedeAutorita } from "../../common/models/tipologiche/autoritagiudiziaria-sedeautorita";
import { MateriaOggetto } from "../../common/models/tipologiche/materia-oggetto";
import { MateriaOggettoArgomento } from "../../common/models/tipologiche/materia-oggetto-argomento";
import { TipoDettaglioEsito } from "../../common/models/tipologiche/tipo-dettaglio-esito";
import { TipoGenericoRimovibile } from "../../common/models/tipologiche/tipo-generico-rimovibile";
import { TitoloEsecutivo } from "../../common/models/titolo-esecutivo";
import { PraticaLavoroCreateAdapter } from "../../lavoro/pratica/models/pratica-lavoro-create-adapter";
import { PraticaPareristicaCreateAdapter } from "../../pareristica/pratica/models/pratica-pareristica-create-adapter";
import { PraticaPenaleCreateAdapter } from "../../penale/pratica/models/pratica-penale-create-adapter";
import { PraticaTributarioCreateAdapter } from "../../tributario/pratica/models/pratica-tributario-create-adapter";
import { PropertiesSettings } from "../configuration/properties-settings";
import { ServicePathsSettings } from "../configuration/service-paths-settings";
import { FascicoloFull } from "src/app/common/models/fascicolo/fascicolo-full";
import { DataExport } from "src/app/common/models/dataExport";
import { PaginatedResponse } from "src/app/common/api/models/paginated";
import { Pagable } from "src/app/lem/models/common/pagable";
import { DettaglioAdempimento } from "src/app/common/models/dettaglio-adempimento";
import { Reato } from "src/app/common/models/reato";
import { NotificaAttivita } from "../models/notifica-attivita";
import { FileData } from "src/app/common/models/file-data";
import { PacchettoVersamento } from "../models/pacchetto-versamento";
import { SKIP_ERROR_INTERCEPTOR } from "src/app/common/interceptors/error.interceptor";

declare var getPraticaMapSync;
declare var recuperaUrlForICalendar;

@Injectable()
export class OperationsService {
  constructor(private http: HttpClient, httpBase: HttpClient) {
    this.http = http;
    //this.httpBase = httpBase;
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return throwError(errMsg);
  }

  download_operator(
    source$: Observable<HttpResponse<any>>
  ): Observable<HttpResponse<any>> {
    return source$.pipe(
      tap((res: HttpResponse<any>) => {
        const filename = res.headers
          .get("content-disposition")
          .split("filename=")[1];
        const blob = new Blob([res.body], {
          type: "application/octet-stream",
        });
        const url = window.URL.createObjectURL(blob);
        const a = window.document.createElement("a");
        window.document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        window.document.body.removeChild(a);
      })
    );
  }

  httpCall(url: string, id: string) {
    return this.http.get(ServicePathsSettings.DOMINIO + url + "/" + id);
  }

  readPratica(url: string, idPratica: string): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + url + "/" + idPratica);
  }

  getPraticaByIdPraticaIdFascicolo(url: string, idPratica: string, idFascicolo): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + url + "/" + idPratica + "/fasc/" + idFascicolo);
  }

  readFascicolo(url: string, idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo
    );
  }

  readClassificazione(idPratica: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_CLASSIFICAZIONE_BY_ID_FASCICOLO.replace(
          "{idPratica}",
          idPratica
        )
    );
  }

  readSezione(url: string, idSezione: string): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get("../../../LocalJson/readSezioneEconomica.json");
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO + url + "/" + idSezione
      );
    }
  }

  getContropartiPrecedentiByPratica(id) {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        "/rs/ops/gp/contropartipraticaprecedente/" +
        id
    );
  }

  setControparteInSezOrdinario(
    controparte: Controparte,
    url,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      controparte
    );
    return response;
  }

  setControparteAsPrimaria(
    idControparte: string,
    url: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idControparte}", idControparte),
      null
    );
    return response;
  }

  removeControparte(url: string, idSezione: string, idControparte: string) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idControparte}", idControparte)
    );
    return response;
  }

  removePatologia(url: string, idSezione: string, idPatologia: string) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idPatologia}", idPatologia)
    );
    return response;
  }

  removeSchedaRecupero(
    url: string,
    idSezione: string,
    idSchedaRecupero: string
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idSchedaRecupero}", idSchedaRecupero)
    );
    return response;
  }

  removeSchedaEsecuzione(
    url: string,
    idSezione: string,
    idSchedaEsecuzione: string
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idSchedaEsecuzione}", idSchedaEsecuzione)
    );
    return response;
  }

  // getBancheDati(url: string, request: BancaDatiRequest):Observable<any>{
  //   return this.http.post(ServicePathsSettings.DOMINIO_API_GATEWAY + url, request);
  // }

  setEsitoInSezesiti(
    url: string,
    idSezione: string,
    esito: Esito
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      esito
    );
  }

  setLetteraDiffidaInSezLettereDiffida(
    url: string,
    idSezione: string,
    letteraDiffida: LetteraDiffida
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      letteraDiffida
    );
  }

  setLegaleIncaricatoInSezLegale(
    legaleIncaricato: LegaleIncaricato,
    url: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      legaleIncaricato
    );
    return response;
  }

  setLegaleInSezLegale(url: string, legale: Legale): Observable<any> {
    return this.http.put(ServicePathsSettings.DOMINIO + url, legale);
  }

  setLegaleIncaricatoAsPrimario(
    idLegale: string,
    url: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idLegaleIncaricato}", idLegale),
      null
    );
    return response;
  }

  removeLegaleIncaricato(
    url: string,
    idSezione: string,
    idLegaleIncaricato: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idLegaleIncaricato}", idLegaleIncaricato)
    );
    return response;
  }

  updateBeneImmobile(
    url: string,
    idSezione: string,
    beneImmobile: BenePignoratoImmobile
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      beneImmobile
    );
  }

  updateDatiGeneraliPratica(
    url: string,
    request: DatiGeneraliPraticaUpdateRequest
  ): Observable<any> {
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }
  updateScadenza(
    url: string,
    request: Scadenza,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    url = url
    .replace("{idSezione}", idSezione)
    .replace("{idFascicolo}", idFascicolo);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  addRinvioToScadenza(
    url: string,
    request: RinvioAdapter,
    idScadenza: string,
    idSezione: string
  ): Observable<any> {
    url = url
      .replace("{idScadenza}", idScadenza)
      .replace("{idSezione}", idSezione);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  evadiScadenza(
    url: string,
    idScadenza: string,
    idSezione: string,
    payload?:any
  ): Observable<any> {
    url = url
      .replace("{idScadenza}", idScadenza)
      .replace("{idSezione}", idSezione);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, payload);
    return response;
  }

  evadiAdempimento(url: string, idScadenza: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + url.replace("{idScadenza}", idScadenza)
    );
  }

  evadiAdempimentoParams(url: string, idScadenza: string, payload): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO + url.replace("{idScadenza}", idScadenza),
      payload
    );
  }


  rinvioAdempimento(url: string, idScadenza, request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO + url.replace("{idScadenza}", idScadenza),
      request
    );
  }

  addAtto(
    url: string,
    request: Atto,
    idFascicolo: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idFascicolo}", idFascicolo)
          .replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addBeneImmobile(
    url: string,
    request: BenePignoratoImmobile,
    idFascicolo: string,
    idSezione: string
  ): Observable<any> {
    //    //DA TOGLIERE
    /*if (request.ubicazione) {
      request.ubicazione.id = '1';
    }*/
    //    //DA TOGLIERE
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idFascicolo}", idFascicolo)
          .replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  removeAtto(url: string, idSezione: string, idAtto: string): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url.replace("{idSezione}", idSezione).replace("{idAtto}", idAtto)
    );
    return response;
  }

  updateAtto(url: string, request: Atto, idSezione: string): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  fascicoloDatiGeneraliUpdate(
    url: string,
    sezioneDatiGeneraliRequest: SezioneDatiGeneraliRequest
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url,
      sezioneDatiGeneraliRequest
    );
  }

  fascicoloDatiGiudiziariUpdate(
    url: string,
    sezioneDatiGiudiziariRequest: SezioneDatiGiudiziariRequest
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url,
      sezioneDatiGiudiziariRequest
    );
  }

  saveClassificazione(
    url: string,
    idPratica: string,
    idSezione: string,
    classificazione: Classificazione
  ): Observable<any> {
    let div: string = " ";
    let token: Array<string> = url.split(div);
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        token[0] +
        idPratica +
        token[1] +
        idSezione +
        token[2],
      classificazione
    );
  }

  removeClassificazioneFromSezOrdinario(
    url: string,
    idSezione: string,
    idClassificazione: string
  ): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idClassificazione}", idClassificazione)
    );
  }

  updatePratica(url, pratica): Observable<any> {
    return this.http.put(ServicePathsSettings.DOMINIO + url, pratica);
  }

  createPraticaPareristica(
    url: string,
    request: PraticaPareristicaCreateAdapter
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  createPraticaAutoritaIndipendente(
    url: string,
    request: PraticaAutoritaIndipendenteCreateAdapter
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  createPraticaCivile(
    url: string,
    request: PraticaCivileCreateAdapter
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  createPraticaTributario(
    url: string,
    request: PraticaTributarioCreateAdapter
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  createPraticaPenale(
    url: string,
    request: PraticaPenaleCreateAdapter
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  createPraticaLavoro(
    url: string,
    request: PraticaLavoroCreateAdapter
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  createPraticaAmministrativa(
    url: string,
    request: PraticaAmministrativaCreateAdapter
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  creatGenericPratica(url: string, request: any): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    console.log(response);
    return response;
  }

  updateAssociativaAltraParte(
    url: string,
    altraParte: AltraParte,
    idSezione
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      altraParte
    );
  }

  updateRiunioneGiudizio(request: RiunioneRequest): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_UPDATE_RIUNISCI_GIUDIZI,
      request
    );
    return response;
  }

  getFascicoliRiunione(request: RiunioneRequest): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_FASCICOLI_RIUNIONE,
      request
    );
    return response;
  }

  updatePagamento(
    url: string,
    request: Pagamento,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addPagamento(
    url: string,
    request: Pagamento,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    idSezione = idSezione ? idSezione : PropertiesSettings.NEW_SEZIONE;
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  removePagamento(
    url: string,
    idSezione: string,
    idPagamento: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idPagamento}", idPagamento);
    return this.http.delete(ServicePathsSettings.DOMINIO + url);
  }

  updateReato(
    url: string,
    request: Reato,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addReato(
    url: string,
    request: Reato,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    idSezione = idSezione ? idSezione : PropertiesSettings.NEW_SEZIONE;
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  removeReato(
    url: string,
    idSezione: string,
    idReato: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idReato}", idReato);
    return this.http.delete(ServicePathsSettings.DOMINIO + url);
  }


  updateIncasso(
    url: string,
    request: Incasso,
    idSezione: string
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
  }

  addRipartizioneIncasso(
    url: string,
    request: IncassoSoggetto,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idFascicolo}", idFascicolo)
          .replace("{idSezione}", idSezione),
      request
    );
  }

  updateRipartizioneIncasso(
    url: string,
    request: IncassoSoggetto,
    idSezione: string
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
  }

  deleteRipartizioneIncasso(
    url: string,
    idSezione: string,
    idIncasso: string,
    idIncassoSoggetto: string
  ): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idIncasso}", idIncasso)
          .replace("{idIncassoSoggetto}", idIncassoSoggetto)
    );
  }
  addIncasso(
    url: string,
    request: Incasso,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    idSezione = idSezione ? idSezione : PropertiesSettings.NEW_SEZIONE;
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  removeIncasso(
    url: string,
    idSezione: string,
    idIncasso: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idIncasso}", idIncasso);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  updateFattura(
    url: string,
    request: Fattura,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addFattura(
    url: string,
    request: Fattura,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    idSezione = idSezione ? idSezione : PropertiesSettings.NEW_SEZIONE;
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  removeFattura(
    url: string,
    idSezione: string,
    idFattura: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFattura}", idFattura);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  updateParcellaGiudiziale(
    url: string,
    request: ParcellaGiudiziale,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addParcellaGiudiziale(
    url: string,
    request: ParcellaGiudiziale,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    idSezione = idSezione ? idSezione : PropertiesSettings.NEW_SEZIONE;
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  removeParcellaGiudiziale(
    url: string,
    idSezione: string,
    idParcellaStragiudiziale: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idParcellaGiudiziale}", idParcellaStragiudiziale);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  updateParcellaStragiudiziale(
    url: string,
    request: ParcellaStragiudiziale,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addParcellaStragiudiziale(
    url: string,
    request: ParcellaStragiudiziale,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    idSezione = idSezione ? idSezione : PropertiesSettings.NEW_SEZIONE;
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  removeParcellaStragiudiziale(
    url: string,
    idSezione: string,
    idParcellaStragiudiziale: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idParcellaStragiudiziale}", idParcellaStragiudiziale);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  addRipartizioneParcella(
    url: string,
    request: ParcellaSoggetto,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idFascicolo}", idFascicolo)
          .replace("{idSezione}", idSezione),
      request
    );
  }

  updateRipartizioneParcella(
    url: string,
    request: ParcellaSoggetto,
    idSezione: string
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
  }

  deleteRipartizioneParcella(
    url: string,
    idSezione: string,
    idParcella: string,
    idParcellaSoggetto: string
  ): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idParcella}", idParcella)
          .replace("{idParcellaSoggetto}", idParcellaSoggetto)
    );
  }

  addParteOrLegaleInSezOrdinario(
    request: Controparte | AltraParte | LegaleIncaricato,
    url: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  deleteDocumento(
    request,
    urlInsert: string,
    idSezione: string
  ): Observable<any> {
    let url = urlInsert + "/" + "/sez/documentazione/" + idSezione + "/documento/";
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url + request.id,
        request
    );
    return response;
  }

  addControparte(
    request: Controparte | AltraParte | LegaleIncaricato,
    urlInsert: string,
    idSezione: string,
    idFascicolo: string
  ):Observable<any> {
    let url = urlInsert + "/" + idFascicolo + "/sez/controparti/" + idSezione + "/controparte";
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      request
    );
    return response;
  }

  deleteControparte(
    urlInsert: string,
    idSezione: string,
    idControparte: string
  ):Observable<any> {
    let url = urlInsert +  "/sez/controparti/" + idSezione + "/controparte/" + idControparte;
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url
    );
    return response;
  }
  
  updateControparte(
    request: Controparte | AltraParte | LegaleIncaricato,
    tipoPratica: string,
    tipoFascicolo: string,
    idSezione: string
  ) {
    let url = ServicePathsSettings.DOMINIO + `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/controparti/${idSezione}/controparte`;
    let response = this.http.put(
      url,
      request
    );
    return response;
  }

  addNewDoc(
    request: DocumentoAllegato,
    urlInsert: string,
    idSezione: string,
    idFascicolo: string
  ) {
    let url = urlInsert + "/" + idFascicolo + "/sez/documentazione/" + idSezione + "/documento";
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      request
    );
    return response;
  }

  addNewAtto(
    request: Atto,
    urlInsert: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let url = urlInsert + "/" + idFascicolo + "/sez/atti/" + idSezione + "/atto";
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      request
    );
    return response;
  }

  updateNewAtto(
    request: Atto,
    tipoPratica: string,
    tipoFascicolo: string,
    idSezione: string
  ) {
    let url = ServicePathsSettings.DOMINIO + `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/atti/${idSezione}/atto`;
    let response = this.http.put(
      url,
      request
    );
    return response;
  }

  deleteNewAtto(
    urlInsert: string,
    idSezione: string,
    idAtto: string
  ):Observable<any> {
    let url = urlInsert +  "/sez/atti/" + idSezione + "/atto/" + idAtto;
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url
    );
    return response;
  }

  addAltraParte(
    request: Controparte | AltraParte | LegaleIncaricato,
    urlInsert: string,
    idSezione: string,
    idFascicolo: string
  ):Observable<any> {
    let url = urlInsert + "/" + idFascicolo + "/sez/altreparti/" + idSezione + "/altraparte";
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      request
    );
    return response;
  }

  updateAltraParte(
    request: Controparte | AltraParte | LegaleIncaricato,
    tipoPratica: string,
    tipoFascicolo: string,
    idSezione: string
  ) {
    let url = ServicePathsSettings.DOMINIO + `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/altreparti/${idSezione}/altraparte`;
    let response = this.http.put(
      url,
      request
    );
    return response;
  }

  deleteAltraParte(
    urlInsert: string,
    idSezione: string,
    idAltraParte: string
  ):Observable<any> {
    let url = urlInsert +  "/sez/altreparti/" + idSezione + "/altraparte/" + idAltraParte;
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url
    );
    return response;
  }

  addPatologia(
    request,
    url: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  updatePatologia(
    request,
    url: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  addSchedaRecupero(
    request,
    url: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  updateSchedaRecupero(
    request,
    url: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  addSchedaEsecuzione(
    request,
    url: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  updateSchedaEsecuzione(
    request,
    url: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  getContropartiBySocieta(id: any, idFascicolo: string): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_CONTROPARTI_BY_SOCIETA.replace(
          "{idSocieta}",
          id
        ) +
        "/" +
        idFascicolo
    );
    return response;
  }

  updateMetadatiDocumento(
    request: UpdateMetadatiDocumentoRequest
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_UPDATE_METADATI_DOCUMENTO,
      request
    );
    return response;
  }

  updateMetadatiDocumentoNewVersion(
    request: UpdateMetadatiDocumentoRequest
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_UPDATE_METADATI_DOCUMENTO_NEW_VERSION,
      request
    );
    return response;
  }

  updateMetadatiDir(
    url,
    request: DocumentoAllegato,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url.replace("/{idFascicolo}", "").replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  updateSezioneDocumento(request, url): Observable<any> {
    console.log(request);
    return this.http.post(ServicePathsSettings.DOMINIO + url, request);
  }

  addDocumentoToSezDocumentiAllegatiOrdinario(
    url: string,
    request: DocumentoAllegato,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idFascicolo}", idFascicolo)
          .replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  removeDocumentoFromSezDocumentiAllegatiOrdinario(
    request,
    url: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url.replace("{idSezione}", idSezione) +
        "/" +
        request.id,
      request
    );
    return response;
  }

  removeDocumentoConFascicolo(
    request,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let endpoint = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH +
                  '/'+ idSezione + '/documento/' + request.id +'/'+ idFascicolo;
                  
    return this.http.delete(endpoint, request);
  }

  annullaProtocollazione(
    payload: { idDocumento: string, idFascicolo: string, idSezione:string },
    ): Observable<any> {
      const url = ServicePathsSettings.DOMINIO 
      + ServicePathsSettings.OPERATIONS_PATH 
      + ServicePathsSettings.GESTIONE_PRATICHE_PATH
      + '/documento/annullaProtocollazione'

    return this.http.put(url, payload);
  }

  addCensimentoDocumenti(url:string,idFascicolo: string, idSezione: string, request: CensimentoDocumenti): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url.replace('{idSezione}', idSezione).replace('{idFascicolo}', idFascicolo), request);
    return response;
  }

  updateCensimentoDocumenti(url:string, idSezione:string, request: CensimentoDocumenti): Observable<any> {
    let response = this.http.put(ServicePathsSettings.DOMINIO + url.replace('{idSezione}', idSezione), request);
    return response;
  }

  removeCensimentoDocumenti(url:string,idSezione:string, idFascicolo:string, idCensimentoDocumento:string): Observable<any> {
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url.replace('{idSezione}', idSezione).replace('{idFascicolo}', idFascicolo).replace('{idCensimentoDocumento}',idCensimentoDocumento));
    return response;
  }

  searchAnagrafiche(url: string, request: any): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updatePetitumDataInteressi(
    url: string,
    request: Petitum,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  removeFondoOnere(
    url: string,
    idSezione: string,
    idFondoOnere: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFondoOnere}", idFondoOnere)
    );
    return response;
  }

  addPetitumValoreEconomico(
    url: string,
    request: Petitum,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updatePetitumValoreEconomico(
    url: string,
    request: Petitum,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }


  addPetitum(
    request: Petitum,
    tipoPratica: string,
    tipoFascicolo: string,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/${idFascicolo}/sez/economici/${idSezione}/petitum`;
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updatePetitum(
    request: Petitum,
    tipoPratica: string,
    tipoFascicolo: string,
    idSezione: string,
  ): Observable<any> {
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/economici/${idSezione}/petitum`;
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }



  updatePetitumAltriImporti(
    url: string,
    request: Petitum,
    idSezione: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updateDataInizioCalcoloPetitum(
    url: string,
    request,
    idSezione: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  addDannoPetitum(url: string, request: DannoBiologico, idSezione: string, idFascicolo: string): Observable<any> {
    url = url.replace('{idSezione}', idSezione);
    url = url.replace('{idFascicolo}', idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updateDannoPetitum(url: string, request, idSezione: string): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  calcolaInteressiLegali(request: CalcoloInteressiRequest): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_CALCOLA_INTERESSI_LEGALI,
      request
    );
    return response;
  }

  addPetitumRevisione(
    url: string,
    request: PetitumRevisione,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updatePetitumRevisione(
    url: string,
    request: PetitumRevisione,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  addContributoUnificato(url: string, request: ContributoUnificato, idSezione: string, idFascicolo: string) : Observable <any> {
    url = url.replace('{idSezione}', idSezione);
    url = url.replace('{idFascicolo}', idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updateContributoUnificato(url: string, request: ContributoUnificato, idSezione: string, idFascicolo: string) : Observable <any> {
    url = url.replace('{idSezione}', idSezione);
    url = url.replace('{idFascicolo}', idFascicolo);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  addFondoRischiRevisione(
    url: string,
    request: PetitumRevisione,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updateFondoRischiRevisione(
    url: string,
    request: PetitumRevisione,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    url = url.replace("{idSezione}", idSezione);
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updateFondoOneri(
    url: string,
    request: SezioneEconomicaFondoOneriAdapter,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addFondoOneri(
    url: string,
    request: SezioneEconomicaFondoOneriAdapter,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    request.id = null;
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idFascicolo}", idFascicolo)
          .replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  insertLiquidati(
    url: string,
    request: Liquidato[],
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  updateLiquidati(
    url: string,
    request: Liquidato,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  addLiquidati(
    url: string,
    request: Liquidato,
    idSezione: string,
    idFascicolo: string
  ) {
    request.id = null;
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idFascicolo}", idFascicolo)
          .replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  setMeritoToEsito(
    urlAddMerito: string,
    esito: Esito,
    idSezione: string,
    dettaglioEsito: DettaglioEsito
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddMerito
          .replace("{idEsito}", esito.id)
          .replace("{idSezione}", idSezione),
      dettaglioEsito
    );
    return response;
  }

  setEsitoSpedizioneToLetteraDiffida(
    urlAddEsitoSpedizione: string,
    idLetteraDiffida: string,
    idSezione: string,
    esitoSpedizione: EsitoSpedizioneDiffida
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddEsitoSpedizione
          .replace("{idLetteraDiffida}", idLetteraDiffida)
          .replace("{idSezione}", idSezione),
      esitoSpedizione
    );
    return response;
  }

  addScadenza(
    urlAddScadenza: string,
    request: Scadenza,
    idSezione: string,
    idFascicolo: string
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddScadenza
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
  }

  addNewScadenza(
    request: Scadenza,
    urlInsert: string,
    idSezione: string,
    idFascicolo: string
  ):Observable<any> {
    let url = urlInsert + "/" + idFascicolo + "/sez/scadenze/" + idSezione + "/scadenza";
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      request
    );
    return response;
  }

  deleteNewScadenza(
    urlInsert: string,
    idSezione: string,
    idScadenza: string
  ):Observable<any> {
    let url = urlInsert +  "/sez/scadenze/" + idSezione + "/scadenza/" + idScadenza;
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url
    );
    return response;
  }


  updateNewScadenza(
    request: Scadenza,
    tipoPratica: string,
    tipoFascicolo: string,
    idSezione: string
  ):Observable<any>  {
    let url = ServicePathsSettings.DOMINIO + `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/scadenze/${idSezione}/scadenza`;
    let response = this.http.put(
      url,
      request
    );
    return response;
  }

  scadenzarioIsTermineInput(
    url: string,
    codiceTermine: string,
    tipoPratica: string,
    tipoFascicolo: string,
    idGrado: string
  ): Observable<any> {
    // return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + '/scadenzario-custom/rs' + ServicePathsSettings.URL_SCADENZA + url + '/?codiceTermine=' + codiceTermine);
    const request = {
      codiceTermine: codiceTermine,
      idTipoPratica: tipoPratica,
      idGradoGiudizio: idGrado,
      idTipoFascicolo: tipoFascicolo,
    };
    return this.http.post(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        url,
      request
    );
  }

  ciSonoScadenze(url: string, request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        "/rs" +
        ServicePathsSettings.URL_SCADENZARIO +
        url,
      request
    );
  }

  getScadenzeCalcolate(url: string, request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        "/rs" +
        ServicePathsSettings.URL_SCADENZARIO +
        url,
      request
    );
  }

  inserisciScadenze(url: string, request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        "/rs" +
        ServicePathsSettings.URL_SCADENZARIO +
        url,
      request
    );
  }

  getCodiciVariantiProcedure(
    url: string,
    codiceTermine: string,
    tipoPratica: string,
    tipoFascicolo: string,
    idGrado: string
  ) {
    // return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + '/scadenzario-custom/rs' + ServicePathsSettings.URL_SCADENZA + url + '/?codiceTermine=' + codiceTermine);
    const request = {
      codiceTermine: codiceTermine,
      idTipoPratica: tipoPratica,
      idGradoGiudizio: idGrado,
      idTipoFascicolo: tipoFascicolo,
    };
    return this.http.post(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        url,
      request
    );
  }

  getCodiciVariantiConteggio(
    url: string,
    codiceTermine: string,
    tipoPratica: string,
    tipoFascicolo: string,
    idGrado: string
  ) {
    // return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + '/scadenzario-custom/rs' + ServicePathsSettings.URL_SCADENZA + url + '/?codiceTermine=' + codiceTermine);
    const request = {
      codiceTermine: codiceTermine,
      idTipoPratica: tipoPratica,
      idGradoGiudizio: idGrado,
      idTipoFascicolo: tipoFascicolo,
    };
    return this.http.post(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        url,
      request
    );
  }

  scadenzarioGetScadenzeAutogenerate(
    url: string,
    idTipoEsito,
    idTipoAtto,
    idTipoScadenza,
    idMotivoScadenza,
    flagSospensionePersonalizzata,
    dataSospsensionePersonalizzataDa,
    dataSospsensionePersonalizzataA,
    dataTermine: number,
    flagAbbreviato: number,
    flagSospensioneTermini: number,
    flagAttore: number,
    tipoPratica: string,
    tipoFascicolo: string,
    idGrado: string
  ): Observable<any> {
    // return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + '/scadenzario/rs' + url + '/?codiceTermine=' + codiceTermine + '&dataTermine=' + dataTermine + '&flagAbbreviato=' + flagAbbreviato + '&flagSospensioneTermini=' + flagSospensioneTermini + '&flagAttore=' + flagAttore);
    const request = {
      //codiceTermineInput: codiceTermine,
      idTipoPratica: tipoPratica,
      idGradoGiudizio: idGrado,
      idTipoFascicolo: tipoFascicolo,
      idTipoEsito: idTipoEsito,
      idTipoAtto: idTipoAtto,
      idTipoScadenza: idTipoScadenza,
      idMotivoScadenza: idMotivoScadenza,
      flagAbbreviazioneTermini: flagAbbreviato,
      flagSospensioneFeriale: flagSospensioneTermini,
      flagSospensionePersonalizzata: flagSospensionePersonalizzata,
      dataSospsensionePersonalizzataDa: dataSospsensionePersonalizzataDa,
      dataSospsensionePersonalizzataA: dataSospsensionePersonalizzataA,
      //codiceVarianteConteggio: conteggio,
      //codiceVarianteProcedura: procedura,
      dataTermine: dataTermine,
      flagAttore: flagAttore,
      //flagVariante: flagVarianti
    };
    return this.http.post(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        url,
      request
    );
  }

  /*  scadenzarioGetScadenzeAutogenerate2(url: string, codiceTermine: string, dataTermine: number, flagAbbreviato: number, flagSospensioneTermini: number, flagAttore: number, procedura: string, conteggio: string): Observable<any> {
      return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + '/scadenzario/rs' + url + '/?codiceTermine=' + codiceTermine + '&dataTermine=' + dataTermine + '&flagAbbreviato=' + flagAbbreviato + '&flagSospensioneTermini=' + flagSospensioneTermini + '&flagAttore=' + flagAttore + '&codiceVarianteProcedura=' + procedura + '&codiceVarianteConteggio=' + conteggio);
    }*/

  scadenzarioEsitiIsEsitoInput(
    url: string,
    idTipoEsito: string,
    codiceTipoData: string,
    idGrado: string
  ): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        url +
        "/?idTipoEsito=" +
        idTipoEsito +
        "&codiceTipoData=" +
        codiceTipoData +
        "&idGrado=" +
        idGrado
    );
  }

  scadenzarioEsitiGetScadenzeAutogenerate(
    url: string,
    dataTermine: number,
    idTipoEsito: string,
    codiceTipoData: string,
    idGrado: string,
    flagAbbreviato: number,
    flagSospensioneTermini: number,
    flagAttore: number,
    tipoPratica: string,
    tipoFascicolo: string
  ): Observable<any> {
    // return this.http.get(ServicePathsSettings.DOMINIO_API_GATEWAY + '/scadenzario/rs' + url + '/?dataTermine=' + dataTermine + '&idTipoEsito=' + idTipoEsito + '&codiceTipoData=' + codiceTipoData + '&idGrado=' + idGrado + '&flagAbbreviato=' + flagAbbreviato + '&flagSospensioneTermini=' + flagSospensioneTermini + '&flagAttore=' + flagAttore);
    const request = {
      idGradoGiudizio: idGrado,
      idTipoEsito,
      codiceTipoData,
      flagAbbreviazioneTermini: flagAbbreviato,
      flagSospensioneFeriale: flagSospensioneTermini,
      dataTermine,
      flagAttore,
      idTipoPratica: tipoPratica,
      idTipoFascicolo: tipoFascicolo,
    };
    return this.http.post(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        url,
      request
    );
  }

  addProvaScritta(
    urlAddProvaScritta: string,
    request: ProvaScritta,
    idSezione: string,
    idFascicolo: string
  ) {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddProvaScritta
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  updateProvaScritta(url: string, request: ProvaScritta, idSezione: string) {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  removeProvaScritta(
    url: string,
    idSezione: string,
    provaScritta: ProvaScritta
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idProvaScritta}", provaScritta.id)
    );
    return response;
  }

  addTitolo(
    urlAddProvaScritta: string,
    request: TitoloEsecutivo,
    idSezione: string,
    idFascicolo: string
  ) {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddProvaScritta
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  updateTitolo(url: string, request: TitoloEsecutivo, idSezione: string) {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  removeTitolo(url: string, idSezione: string, titolo: TitoloEsecutivo) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idTitoloEsecutivo}", titolo.id)
    );
    return response;
  }

  addDocumentoToEntity(
    url: string,
    idEntity: string,
    request: DocumentoAllegato
  ) {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url.replace("{entityId}", idEntity),
      request
    );
    return response;
  }

  removeDocumentoToEntity(request, url: string, idEntity: string) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{entityId}", idEntity)
          .replace("{idDocumento}", request.id),
      request
    );
    return response;
  }

  addEsito(
    urlAddEsito: string,
    idSezione: string,
    idFascicolo: string,
    request: Esito
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddEsito
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  eliminaEsito(
    urlEliminaEsito: string,
    idEsito: string,
    idSezioneEsiti: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        urlEliminaEsito
          .replace("{idSezione}", idSezioneEsiti)
          .replace("{idEsito}", idEsito)
    );
    return response;
  }

  addLetteraDiffida(
    urlAddLetteraDiffida: string,
    idSezione: string,
    idFascicolo: string,
    request: LetteraDiffida
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddLetteraDiffida
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      request
    );
    return response;
  }

  eliminaLetteraDiffida(
    urlEliminaLetteraDiffida: string,
    idLetteraDiffida: string,
    idSezioneLettereDiffida: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        urlEliminaLetteraDiffida
          .replace("{idSezione}", idSezioneLettereDiffida)
          .replace("{idLetteraDiffida}", idLetteraDiffida)
    );
    return response;
  }

  eliminaScadenza(
    urlEliminaScadenza: string,
    idSezione: string,
    idScadenza: string
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        urlEliminaScadenza
          .replace("{idSezione}", idSezione)
          .replace("{idScadenza}", idScadenza)
    );
    return response;
  }

  eliminaScadenzaAdempimento(
    urlEliminaScadenza: string,
    idFascicolo: string,
    idScadenza: string
  ) {
    let url = urlEliminaScadenza.replace("{idFascicolo}", idFascicolo);
    url = urlEliminaScadenza.replace("{idScadenza}", idScadenza);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  eliminaAltraParte(
    urlEliminaAltraParte: string,
    idSezione: string,
    idAltraParte: string
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        urlEliminaAltraParte
          .replace("{idSezione}", idSezione)
          .replace("{idAltraParte}", idAltraParte)
    );
    return response;
  }

  getAnagrafica(
    url: string,
    idAnagrafica: string,
    isParte: boolean
  ): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        url.replace(isParte ? "{idParte}" : "{idLegale}", idAnagrafica)
    );
    return response;
  }

  getTemplatesByEntity(idEntity): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        ServicePathsSettings.URL_FORMULARIO +
        "rs/templates/entita/" +
        idEntity
    );
    return response;
  }

  generaDocumentoAnagrafica(objDoc): Observable<any> {
    // let response = this.http.post(ServicePathsSettings.DOMINIO_API_GATEWAY + ServicePathsSettings.URL_FORMULARIO + 'rs/generaDocumentoAnagrafica', objDoc);
    // return response;
    return this.http
      .post(
        ServicePathsSettings.DOMINIO_API_GATEWAY +
          ServicePathsSettings.URL_FORMULARIO +
          "rs/generaDocumentoAnagrafica",
        objDoc,
        {
          responseType: "arraybuffer",
          observe: "response",
          withCredentials: true,
        }
      )
      .pipe(this.download_operator);
  }

  updateClassificazione(
    urlUpdateClassificazione: string,
    idSezione: string,
    request: Classificazione
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        urlUpdateClassificazione.replace("{idSezione}", idSezione),
      request
    );
    return response;
  }

  createClassificazione(
    urlCreateClassificazione: string,
    idSezione: string,
    idPratica: string,
    request
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlCreateClassificazione
          .replace("{idSezione}", idSezione)
          .replace("{idPratica}", idPratica),
      request
    );
    return response;
  }

  setClassificazionePrincipale(
    setClassificazionePrincipaleUrl: string,
    idSezione: string,
    idClassificazione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        setClassificazionePrincipaleUrl
          .replace("{idSezione}", idSezione)
          .replace("{idClassificazione}", idClassificazione),
      null
    );
    return response;
  }

  deleteFile(refDocumentale: string) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.DELETE_FILE_TO_DOCUMENTALE +
        "/" +
        refDocumentale
    );
    return response;
  }

  disattivaControparte(
    idControparte: string,
    url: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idControparte}", idControparte),
      null
    );
    return response;
  }

  disattivaLegaleIncaricato(
    idLegaleIncaricato: string,
    url: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idLegaleIncaricato}", idLegaleIncaricato),
      null
    );
    return response;
  }

  disattivaAltraParte(
    idAltraParte: string,
    url: string,
    idSezione: string
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idAltraParte}", idAltraParte),
      null
    );
    return response;
  }

  getScaglioniByFascicolo(
    url: string,
    idFascicolo,
    idCompetenzaParcella
  ): Observable<any> {
    url = url.replace("{idFascicolo}", idFascicolo);
    url = url.replace("{idCompetenzaParcella}", idCompetenzaParcella);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  deleteFascicolo(url: string, idFascicolo: string) {
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  defineFascicolo(url: string, idFascicolo: string) {
    url = url.replace("{idFascicolo}", idFascicolo);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  deletePratica(url: string, idPratica: string) {
    url = url.replace("{idPratica}", idPratica);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  getGestioneMetadatiFascicolo(idFascicolo: string) {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        `/rs/ops/gp/metadatiFascicolo/${idFascicolo}`
    );
  }

  updateEsito(
    updateUrl: string,
    idEsito: string,
    idSezione: string,
    dettaglioEsito: DettaglioEsito
  ) {
    let url: string = updateUrl
      .replace("{idEsito}", idEsito)
      .replace("{idSezione}", idSezione);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      dettaglioEsito
    );
    return response;
  }

  updateDettagliEsito(
    updateUrl: string,
    idEsito: string,
    idSezione: string,
    dettagliEsito: DettaglioEsito[]
  ) {
    let url: string = updateUrl
      .replace("{idEsito}", idEsito)
      .replace("{idSezione}", idSezione);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      dettagliEsito
    );
    return response;
  }

  addDettagliEsito(
    urlAddMerito: string,
    esito: Esito,
    dettagliEsito: DettaglioEsito[]
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddMerito
          .replace("{idEsito}", esito.id)
          .replace("{idEsito}", esito.id),
      dettagliEsito
    );
    return response;
  }

  eliminaMerito(
    url: string,
    idEsito: string,
    idDettaglioEsito: string,
    idSezione: string
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idEsito}", idEsito)
          .replace("{idDettaglioEsito}", idDettaglioEsito)
    );
    return response;
  }

  updateLetteraDiffida(
    updateUrl: string,
    idLetteraDiffida: string,
    idSezione: string,
    esitoSpedizione: EsitoSpedizioneDiffida
  ) {
    let url: string = updateUrl
      .replace("{idLetteraDiffida}", idLetteraDiffida)
      .replace("{idSezione}", idSezione);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      esitoSpedizione
    );
    return response;
  }

  eliminaEsitoSpedizione(
    url: string,
    idLetteraDiffida: string,
    idEsitoSpedizione: string,
    idSezione: string
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idLetteraDiffida}", idLetteraDiffida)
          .replace("{idEsitoSpedizione}", idEsitoSpedizione)
    );
    return response;
  }

  eliminaBeneImmobile(
    url: string,
    idSezione: string,
    idBenePignoratoImmobile: string
  ) {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idBenePignoratoImmobile}", idBenePignoratoImmobile)
    );
    return response;
  }

  eliminaBeneMobile(
    url: string,
    idSezione: string,
    idBenePignoratoMobile: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idBenePignoratoMobile}", idBenePignoratoMobile)
    );
    return response;
  }

  createBeneMobile(
    urlAddBene: string,
    idFascicolo: string,
    idSezione: string,
    beneMobile: BeneMobile
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddBene
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      beneMobile
    );
    return response;
  }


  eliminaDatiPignoramento(
    url: string,
    idSezione: string,
    idDatiPignoramento: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url
          .replace("{idSezione}", idSezione)
          .replace("{idDatiPignorati}", idDatiPignoramento)
    );
    return response;
  }

  createDatiPignoramento(
    urlAddBene: string,
    idFascicolo: string,
    idSezione: string,
    datiPignoramento: DatiPignoramento
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlAddBene
          .replace("{idSezione}", idSezione)
          .replace("{idFascicolo}", idFascicolo),
      datiPignoramento
    );
    return response;
  }

  updateDatiPignoramento(
    urlUpdate: string,
    idSezione: string,
    datiPignoramento: DatiPignoramento
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        urlUpdate.replace("{idSezione}", idSezione),
        datiPignoramento
    );
    return response;
  }



  // ASSEGNAZIONE

  // ASSEGNAZIONE - ORIZZONTALI

  getGruppiTerritoriali(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_GRUPPI_TERRITORIALI
    );
  }

  getGruppiTerritorialiCompetenti(idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_GRUPPI_TERRITORIALI_COMPETENTI +
        "/" +
        idFascicolo
    );
  }

  getGruppiVisibilitaAssociati(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_GRUPPI_TERRITORIALI_VISIBILITA_ASSOCIATI
    );
  }

  gruppiFilterByPrefix(prefix: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_GRUPPI_FILTER +
        "/" +
        prefix
    );
  }

  getUtenteAssegnatario(idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_UTENTE_ASSEGNATARIO +
        "/" +
        idFascicolo
    );
  }

  getUtenteProfilo(idUtente: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_UTENTI +
        "/" +
        idUtente
    );
  }

  getUserProfile(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_LOGGER_USER_PROFILE
    );
  }

  // ASSEGNAZIONE - VERTICALI GET

  concludiLavorazionePratica(url: string, idFascicolo: string) {
    return this.http.get(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo
    );
  }

  concludiFaseAssegnazioneLegale(url: string, idFascicolo: string) {
    return this.http.get(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo
    );
  }

  concludiFaseInserimento(idFascicolo: string, url: string) {
    return this.http.get(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo
    );
  }

  riassegnaLavorazione(url: string, idFascicolo: string) {
    return this.http.get(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo
    );
  }

  // ASSEGNAZIONE - VERTICALI POST

  concludiFaseSmistamento(
    url: string,
    idFascicolo: string,
    gruppoTerritoriale: GruppoTerritoriale
  ) {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo,
      gruppoTerritoriale
    );
    return response;
  }

  concludiFaseAssegnazione(
    url: string,
    idFascicolo: string,
    request: AssegnazioneGruppiTerritorialiRequest
  ) {
    return this.http.post(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo,
      request
    );
  }

  rifiutoFaseSmistamento(url: string, idFascicolo: string, note: Note) {
    if (ServicePathsSettings.isLocal) {
      // TODO
    } else {
      return this.http.post(
        ServicePathsSettings.DOMINIO + url + "/" + idFascicolo,
        note
      );
    }
  }

  rifiutoFaseAssegnazione(url: string, idFascicolo: string, note: Note) {
    return this.http.post(
      ServicePathsSettings.DOMINIO + url + "/" + idFascicolo,
      note
    );
  }

  // ORIZZONTALE
  updateUtenteAssegnatario(
    idFascicolo: string,
    request: AssegnazioneGruppiTerritorialiRequest
  ) {
    return this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_UPDATE_UTENTE_ASSEGNATARIO +
        "/" +
        idFascicolo,
      request
    );
  }

  getAssegnatari(gruppi: GruppoTerritoriale[] , fascicolo : FascicoloFull) {
    let visibility = null;
    if(fascicolo){
      if(fascicolo.tipoVisibilita){
        visibility = fascicolo.tipoVisibilita.label;
      } else if(fascicolo.praticaBase && fascicolo.praticaBase.tipoVisibilita){
        visibility = fascicolo.praticaBase.tipoVisibilita.label;
      }
    }

    const queryParams = `?visibility=${visibility}`;

    return this.http.post(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GET_ASSEGNATARI + queryParams,
      gruppi
    );
  }

  // ASSEGNAZIONE - FINE

  updateBeneMobile(
    urlUpdateBene: string,
    idSezione: string,
    beneMobile: BeneMobile
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        urlUpdateBene.replace("{idSezione}", idSezione),
      beneMobile
    );
    return response;
  }

  // TIPOLOGICHE OPERATIONS

  getTipologicaOptions(tipologicaTag: string): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_HELPERS_LIST.replace(
          "{tipologicaTag}",
          tipologicaTag
        )
    );
    console.log(response);
    return response;
  }

  addTipologicaOption(
    tipologicaTag: string,
    tipologicaModel: TipoGenericoRimovibile
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_TIPOLOGICA_ADD.replace(
          "{tipologicaTag}",
          tipologicaTag
        ),
      tipologicaModel
    );
    return response;
  }

  getTipologicheAutoritaGiudiziariaOptions() {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
        "/autoritagiudiziaria"
    );
    return response;
  }

  getTipologicheSediOptions() {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
        "/sedeterritoriale"
    );
    return response;
  }

  updateTipologicheAutoritaGiudiziariaOptions(
    autoritaGiudiziaria: AutoritaGiudiziaria
  ) {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
        "/autoritagiudiziaria",
      autoritaGiudiziaria
    );
    return response;
  }

  updateTipologicaOption(
    tipologicaTag: string,
    tipologicaModel: TipoGenericoRimovibile
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_TIPOLOGICA_UPDATE.replace(
          "{tipologicaTag}",
          tipologicaTag
        ),
      tipologicaModel
    );
    return response;
  }

  updateTipoDettaglioEsito(request: TipoDettaglioEsito): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_UPDATE_TIPO_DETTAGLIO_ESITO,
      request
    );
    return response;
  }

  restoreTipologicaOption(
    tipologicaTag: string,
    id: string,
    tipologicaModel: TipoGenericoRimovibile
  ): Observable<any> {
    let url = ServicePathsSettings.URL_PATH_TIPOLOGICA_RESTORE;
    url = url.replace("{tipologicaTag}", tipologicaTag);
    url = url.replace("{id}", id);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      tipologicaModel
    );
    return response;
  }

  eliminaTipologicaOption(
    tipologicaTag: string,
    idTipologicaModel: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_TIPOLOGICA_REMOVE.replace(
          "{tipologicaTag}",
          tipologicaTag
        ).replace("{id}", idTipologicaModel)
    );
    return response;
  }

  // TABELLE OPERATIONS

  getTabellaOptions(tabellaTag: string): Observable<any> {
    let url = ServicePathsSettings.URL_PATH_TABELLA_HELPERS_LIST;
    url = url.replace("{tabellaTag}", tabellaTag);
    let response = this.http.get(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  addTabellaOption(tabellaTag: string, tabellaModel: any): Observable<any> {
    let url = ServicePathsSettings.URL_PATH_TABELLA_ADD;
    url = url.replace("{tabellaTag}", tabellaTag);
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      tabellaModel
    );
    return response;
  }

  updateTabellaOption(tabellaTag: string, tabellaModel: any): Observable<any> {
    let url = ServicePathsSettings.URL_PATH_TABELLA_UPDATE;
    url = url.replace("{tabellaTag}", tabellaTag);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      tabellaModel
    );
    return response;
  }

  restoreTabellaOption(
    tabellaTag: string,
    id: string,
    tabellaModel: any
  ): Observable<any> {
    let url = ServicePathsSettings.URL_PATH_TABELLA_RESTORE;
    url = url.replace("{tabellaTag}", tabellaTag);
    url = url.replace("{id}", id);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      tabellaModel
    );
    return response;
  }

  eliminaTabellaOption(tabellaTag: string, id: string): Observable<any> {
    let url = ServicePathsSettings.URL_PATH_TABELLA_REMOVE;
    url = url.replace("{tabellaTag}", tabellaTag);
    url = url.replace("{id}", id);
    let response = this.http.delete(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  // MIA RICERCA OPERATIONS

  addMiaRicercaElement(miaRicerca: MiaRicerca): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.TEMPLATE_ADD,
      miaRicerca
    );
    return response;
  }

  getMiaRicercaAllElements(): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.LIST_TEMPLATES
    );
    return response;
  }

  eliminaMiaRicercaElement(miaRicercaId: string): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.ELIMINA_TEMPLATE.replace("{id}", miaRicercaId)
    );
    return response;
  }

  // GESTIONE CENTRALIZZATA DI TUTTE LE ANAGRAFICHE -- INIZIO
  // (autorita-giudiziaria,autorita-indipendente,comune,direzione-territoriale-lavoro,
  // legale,parte,provincia,sedeterritoriale,soggetto)

  getAnagraficaElementById(anagrafica: Anagrafica): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICA_BY_ID.replace(
          "{anagraficaTag}",
          anagrafica.getAnagraficaTAG
        ).replace("id}", anagrafica.id)
    );
    return response;
  }

  addAnagraficaElement(anagrafica: Anagrafica): Observable<any> {
    console.log(anagrafica, 'ANAGRAFICA')
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICA_ADD.replace(
          "{anagraficaTag}",
          anagrafica.getAnagraficaTAG
        ),
      anagrafica
    );
    return response;
  }

  addNewAnagrafica(anagrafica: Anagrafica): Observable<any> {
    let url = "/rs/ang/gp/parte"
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      anagrafica
    );
    return response;
  }

 updateAnagraficaElement(anagrafica: Anagrafica): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICA_UPDATE.replace(
          "{anagraficaTag}",
          anagrafica.getAnagraficaTAG
        ),
      anagrafica
    );
    return response;
  }

  updateAnagraficaElementParte(anagrafica: Anagrafica): Observable<any> {
    let url = "/rs/ang/gp/parte"
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      anagrafica
    );
    return response;
  }

  eliminaAnagraficaElement(
    anagraficaTag: string,
    anagraficaId: string
  ): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICA_REMOVE.replace(
          "{anagraficaTag}",
          anagraficaTag
        ).replace("{id}", anagraficaId)
    );
    return response;
  }

  getAnagraficaAllElements(anagraficaTag: string): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICHE_LIST.replace(
          "{anagraficaTag}",
          anagraficaTag
        )
    );
    return response;
  }

  getAnagraficaAllElementsAttivi(anagraficaTag: string): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICHE_LIST_ATTIVE.replace(
          "{anagraficaTag}",
          anagraficaTag
        )
    );
    return response;
  }

  restoreAnagraficaOption(
    anagraficaTag: string,
    anagrafica: Anagrafica
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PATH_ANAGRAFICA_RESTORE.replace(
          "{anagraficaTag}",
          anagraficaTag
        ).replace("{id}", anagrafica.id),
      anagrafica
    );
    return response;
  }
  // GESTIONE CENTRALIZZATA DI TUTTE LE ANAGRAFICHE -- FINE

  insertAssociativaAutoritaSede(
    request: AutoritaGiudiziariaSedeAutorita
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ASSOCIATIVA_AUTORITA_SEDE,
      request
    );
  }

  updateAssociativaAutoritaSede(
    request: AutoritaGiudiziariaSedeAutorita
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ASSOCIATIVA_AUTORITA_SEDE,
      request
    );
  }

  deleteAssociativaAutoritaSedeById(id: string): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ASSOCIATIVA_AUTORITA_SEDE +
        "/" +
        id
    );
    return response;
  }

  getAssociativeAutoritaSede(): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ASSOCIATIVA_AUTORITA_SEDE
    );
    return response;
  }

  filterAssociativeAutoritaSede(
    request: AutoritaGiudiziariaSedeAutorita
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_FILTER_ASSOCIATIVE_AUTORITA_SEDE,
      request
    );
  }

  getAssociativaAutoritaSedeById(id: string): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ASSOCIATIVA_AUTORITA_SEDE +
        "/" +
        id
    );
    return response;
  }

  copiaPratica(url: string, request): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO + url, request);
  }

  riunisciGiudizi(url: string, request: RiunioneRequest): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO + url, request);
  }

  loginOp(url: string, request: any): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  getProssimiAdempimenti(
    request:
      | {
          fromResult: number;
        }
      | {
          fromResult: number;
          size: number;
        }
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PROSSIMI_ADEMPIMENTI,
      request
    );
    return response;
  }

  getAdempimentiInevasi(
    request:
      | {
          fromResult: number;
        }
      | {
          fromResult: number;
          size: number;
        }
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ADEMPIMENTI_INEVASI,
      request
    );
    return response;
  }

  getPraticheCorrelate(url: string, idPratica: string): Observable<any> {
    url = url.replace("{idPratica}", idPratica);
    let response = this.http.get(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  correlaPratiche(url: string, idPratica: string, idPratiche: string[]) {
    url = url.replace("{idPratica}", idPratica);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url,
      idPratiche
    );
    return response;
  }

  getPratichePrecedenti(url: string, idPratica: string): Observable<any> {
    url = url.replace("{idPratica}", idPratica);
    let response = this.http.get(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  pratichePrecedenti(idPratica: string, pratichePrecedenti: string[]) {
    const url = "/rs/ops/gp/praticheprecedenti/" + idPratica;
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      pratichePrecedenti
    );
    return response;
  }

  eliminaCorrelazionePratiche(url: string, idPratica: string, idPratiche: any) {
    url = url.replace("{idPratica}", idPratica);
    url = url.replace("{idPraticaDaScorrelare}", idPratiche[0]);
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url,
      idPratiche
    );
    return response;
  }

  eliminaPraticaPrecedente(url: string, idPratica: string, idPratiche: any) {
    url = url.replace("{idPratica}", idPratica);
    url = url.replace("{idPraticaPrecedente}", idPratiche[0]);
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url,
      idPratiche
    );
    return response;
  }

  aggiornamentoMassivoClassificazione(
    url: string,
    request: AggiornamentoClassificazioniRequest
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  scheda(url: string, idPratica: string, idFascicolo: string): Observable<any> {
    url = url.replace("{idPratica}", idPratica);
    if (idFascicolo) {
      url = url.replace("{idFascicolo}", idFascicolo);
    }
    let response = this.http.get(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  creaDefinisciFascicolo(
    url: string,
    request: DefinisciFascicoloRequest
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  aggiornaDefinisciFascicolo(
    url: string,
    request: DefinisciFascicoloRequest
  ): Observable<any> {
    let response = this.http.put(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  eliminaDefinisciFascicolo(url: string, idFascicolo: string): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        url.replace("definizione", idFascicolo + "/definizione")
    );
    return response;
  }

  eliminaRiunioneGiudizio(request: RiunioneRequest): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_REMOVE_RIUNISCI_GIUDIZI,
      request
    );
    return response;
  }

  archiviaPratica(
    tipoPratica: string,
    request: ArchiviaPraticaRequest
  ): Observable<any> {
    let pratica = getPraticaMapSync(tipoPratica);
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + pratica.pathArchivia,
      request
    );
    return response;
  }

  addTemplateUtente(
    url: string,
    request: TemplateUtenteProfilo
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updateTemplateUtente(
    url: string,
    request: TemplateUtenteProfilo
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO + url.replace("{idTemplate}", request.id),
      request
    );
    return response;
  }

  deleteTemplateUtente(url: string, idTemplate: string): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url.replace("{idTemplate}", idTemplate)
    );
    return response;
  }

  getTemplatesUtente(url: string): Observable<any> {
    let response = this.http.get(ServicePathsSettings.DOMINIO + url);
    return response;
  }

  getTemplatesUtentePaginati(
    url: string,
    templatesProfiloRequest: TemplatesProfiloRequest
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      templatesProfiloRequest
    );
    return response;
  }

  getTemplateUtente(url: string, idTemplate: string): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO + url.replace("{idTemplate}", idTemplate)
    );
    return response;
  }

  callAdempimentiCalendario(
    url: string,
    request: {
      dateTo: number;
      dateFrom: number;
      size: string;
      visibilita: string;
    }
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  prendiNotificheAttivitaPaginate(request: {
    fromResult: number;
  }): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_NOTIFICHE_ATTIVITA,
      request
    );
    return response;
  }

  segnalaNotificaLetta(idNotifica: string): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_SEGNALA_NOTIFICA_COME_LETTA.replace(
          "{idNotifica}",
          idNotifica
        )
    );
    return response;
  }

  eliminaNotifica(idNotifica: string): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ELIMINA_NOTIFICA.replace(
          "{idNotifica}",
          idNotifica
        )
    );
    return response;
  }

  addUtenteProfilo(
    url: string,
    request: UtenteProfiloRequest
  ): Observable<any> {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, request);
    return response;
  }

  updateUtenteProfilo(
    url: string,
    request: UtenteProfiloRequest
  ): Observable<any> {
    let response = this.http.put(
      ServicePathsSettings.DOMINIO +
        url.replace("{idUtente}", request.utente.id),
      request
    );
    return response;
  }

  deleteUtenteProfilo(url: string, idUtente: string): Observable<any> {
    let response = this.http.delete(
      ServicePathsSettings.DOMINIO + url.replace("{idUtente}", idUtente)
    );
    return response;
  }

  prendiAttivitaCompletarePaginate(request: {
    fromResult: number;
  }): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_PRENDI_ATTIVITA_COMPLETARE,
      request
    );
    return response;
  }

  getUtenti(): Observable<any> {
    let response = this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GET_UTENTI
    );
    return response;
  }

  getUtentiPaginati(
    url: string,
    utentiProfiloRequest: UtentiProfiloRequest
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO + url,
      utentiProfiloRequest
    );
    return response;
  }

  // integrazione di getUtentiDaGruppoTerritoriale() IN PROGRESS
  getUtentiDaGruppoTerritoriale(gruppo): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_UTENTI_BY_GRUPPO_TERRITORIALE,
      gruppo
    );
    return response;
  }

  getUtentiDaGruppoDinamica(url, gruppo) {
    let response = this.http.post(ServicePathsSettings.DOMINIO + url, gruppo);
    return response;
  }

  eliminaCorrispondenzaMateriaOggetto(idCorrispondenzaMateriaOggetto: string) {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_MATERIA_OGGETTI +
        "/" +
        idCorrispondenzaMateriaOggetto
    );
  }

  eliminaCorrispondenzaMateriaOggettoArgomento(
    idCorrispondenzaMateriaOggettoArgomento: string
  ) {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_MATERIA_OGGETTO_ARGOMENTI +
        "/" +
        idCorrispondenzaMateriaOggettoArgomento
    );
  }

  aggiungiMateriaOggetto(materiaOggetto: MateriaOggetto) {
    return this.http.post(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_MATERIA_OGGETTI,
      materiaOggetto
    );
  }

  aggiungiMateriaOggettoArgomento(
    materiaOggettoArgomento: MateriaOggettoArgomento
  ) {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_MATERIA_OGGETTO_ARGOMENTI,
      materiaOggettoArgomento
    );
  }

  getGruppiByRuoli(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GET_TEMPLATE_RUOLI
    );
  }

  getGruppiByPermessi(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_TEMPLATE_PERMESSI
    );
  }

  getGruppiOrganizzativi(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_TEMPLATE_GRUPPI_ORGANIZZATIVI
    );
  }

  getGruppiVisibilita(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_TEMPLATE_GRUPPI_VISIBILITA
    );
  }

  getGruppiDinamica(url: string): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  updateGruppiDinamica(url: string, request, id: string): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url + "/" + id,
      request
    );
  }

  public getUrlForICalendar(): Observable<any> {
    return this.http.get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ADEMPIMENTI_CALENDARIO_ICALENDAR,
      {
        responseType: "text",
      }
    ).pipe(
      map(it =>
          ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ADEMPIMENTI_CALENDARIO_ICALENDAR + it
      )
    );
  }

  addTemplateRicercaPersonalizzata(
    miaRicercaRequest: MiaRicerca
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.TEMPLATE_ADD,
      miaRicercaRequest
    );
  }

  addTemplateEstrazionePersonalizzata(
    miaRicercaRequest: MiaRicerca
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.TEMPLATE_ESTRAZIONE_ADD,
      miaRicercaRequest
    );
  }

  impostaTemplateRicercaPersonalizzataComePredefinito(
    id: string,
    location: string
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.IMPOSTA_TEMPLATE_PREDEFINITO.replace(
          "{idTemplate}",
          id
        ).replace("{location}", location),
      undefined
    );
  }

  eliminaTemplateRicercaPersonalizzata(id: string): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.ELIMINA_TEMPLATE.replace("{idTemplate}", id),
      undefined
    );
  }

  ///FORMULARIO
  getAllFormule(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "/hashtag"
    );
  }

  getFormula(id): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "hashtag/" +
      id,
      undefined
    );
  }

  updateFormula(obj): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "hashtag/" +
      obj.id,
      obj
    );
  }

  deleteFormula(id): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "hashtag/" +
      id
    );
  }

  addFormula(obj): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "hashtag",
      obj
    );
  }

  getAllTemplates(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template"
    );
  }
  getTemplate(id): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template/" +
      id
    );
  }

  updateTemplate(payload, id): Observable<any> {
    // let headers = {
    //   'Accept': 'application/json',
    //   'TLF_USER': localStorage.getItem('TLF_USER'),
    //   'TLF_SDOMAIN': localStorage.getItem('TLF_SDOMAIN'),
    //   'TLF_PRODUCT': 'teleforum',
    //   'TLF_TENANT': localStorage.getItem('TLF_TENANT'),
    // }
    return this.http.put(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template/" + id,
      payload
    );
  }

  deleteTemplate(id): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template/" +
      id
    );
  }

  addTemplate(obj): Observable<any> {
    // let headers = {
    //   'Accept': 'application/json',
    //   'TLF_USER': localStorage.getItem('TLF_USER'),
    //   'TLF_SDOMAIN': localStorage.getItem('TLF_SDOMAIN'),
    //   'TLF_PRODUCT': 'teleforum',
    //   'TLF_TENANT': localStorage.getItem('TLF_TENANT'),
    // }
    return this.http.post(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template",
      obj
    );
  }

  getAllTipiFascicolo(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + "/rs/tpl/gp/tipofascicolo"
    );
  }

  getAllTipiFascicoloAttivi(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + "/rs/tpl/gp/tipofascicolo/attive"
    );
  }

  getAllTipiEntita(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template/entita"
    );
  }

  getAssociazione(id): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template-entita/" +
      id
    );
  }

  setAssociazione(obj, id): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template-entita/" + id,
      obj
    );
  }

  getDelimitatori(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template/delimitatori"
    );
  }

  getTemplateFascicolo(id): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "template/entita/" +
      id
    );
  }

  generaDocumentoFascicolo(obj): Observable<any> {
    // return this.http.post(ServicePathsSettings.DOMINIO_API_GATEWAY + ServicePathsSettings.URL_FORMULARIO + 'rs/generaDocumentoFascicolo', obj);
    return this.http
      .post(
        ServicePathsSettings.DOMINIO +
        "/rs" +
        ServicePathsSettings.URL_FORMULARIO +
        "generazioneDoc/fascicolo",
        obj,
        {
          responseType: "arraybuffer",
          observe: "response",
          withCredentials: true,
        }
      )
      .pipe(this.download_operator);
  }

  getDescriptions(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      "/rs" +
      ServicePathsSettings.URL_FORMULARIO +
      "dizionario-attributo"
    );
  }
  createFascicoloGeneric(url: string, request: any): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO + url, request);
  }

  copyFascicoloGeneric(url: string, request: any): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO + url, request);
  }

  updateFascicoloGeneric(url: string, request: any): Observable<any> {
    return this.http.put(ServicePathsSettings.DOMINIO + url, request);
  }

  getDettaglioFascicoloGenerico(
    tipoPratica,
    tipoFascicolo,
    idFascicolo
  ): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        "/rs/ops/gp/" +
        tipoPratica +
        "/fasc/" +
        tipoFascicolo +
        "/" +
        idFascicolo
    );
  }

  getFormTenantByTipo(idTipoPratica, idTipoFascicolo): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/menu/rs/formtenant/" +
        idTipoPratica +
        "/" +
        idTipoFascicolo
    );
  }

  getFormTenantByTipoPratica(idTipoPratica): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/menu/rs/formtenant/" +
        idTipoPratica
    );
  }

  getScadenzaScadenzario(idScadenza): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        "getScadenza/" +
        idScadenza
    );
  }

  getParameters(idParameters): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        "getParameters/" +
        idParameters
    );
  }

  listScadenzaScadenzario(idTipoFascicolo): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        "getScadenzeByIdTipoFascicolo/" +
        idTipoFascicolo
    );
  }

  listScadenzaScadenzarioAvanzata(obj): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        "searchScadenza",
      obj
    );
  }

  getTerminiScadenzario(request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO + "/rs/scadenzario/termini",
      request
    );
  }

  aggiungiTerminiScadenzario(request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO + "/rs/scadenzario",
      request
    );
  }

  modificaTermineScadenzario(request): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + "/rs/scadenzario/termine",
      request
    );
  }

  eliminaTermineScadenzario(idTermine): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO + "/rs/scadenzario/termine/" + idTermine
    );
  }

  addScadenzaScadenzario(obj): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        "insertScadenza",
      obj
    );
  }

  deleteScadenzaScadenzarioAvanzata(id): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO_API_GATEWAY +
        "/scadenzario-custom/rs" +
        ServicePathsSettings.URL_SCADENZA +
        "deleteScadenza/" +
        id
    );
  }

  addDettaglioAdempimento(
    url: string,
    request: DettaglioAdempimento,
  ): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
      url,
      request
    );
  }

  updateDettaglioAdempimento(
    url: string,
    request: DettaglioAdempimento,
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + url,
      request
    );
  }

  deleteDettaglioAdempimento(url: string): Observable<any> {
    return this.http.delete(ServicePathsSettings.DOMINIO + url);
  } 

  inserimentoPraticaVeloce(request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.GESTIONE_PRATICHE_BASE_PATH +
        "/pratica",
      request
    );
  }

  getCategorieLegaleIncaricato(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_CATEGORIE_LEGALE_INCARICATO_PRATICA
    );
  }

  //TARIFFE CONTRATTI
  getPrestazioni(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + "/rs/tpl/gp/attivitalegale"
    );
  }
  getGrado(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + "/rs/tpl/gp/grado");
  }

  getLealiCompoBox(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + "/rs/ang/gp/legale");
  }

  salvaContratto(request): Observable<any> {
    return this.http.post(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/contrattolegale",
      request
    );
  }

  modificaContratto(request): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/contrattolegale",
      request
    );
  }

  getContratto(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/contrattolegale"
    );
  }

  modificaTariffa(request): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/tariffalegale",
      request
    );
  }

  getTariffe(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/tariffalegale"
    );
  }

  eliminaTariffa(id): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/tariffalegale/" + id
    );
  }

  deleteContratto(request): Observable<any> {
    return this.http.delete(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/contrattolegale/" + request
    );
  }

  getLegaliConsigliati(idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.SEARCH_PATH +
        ServicePathsSettings.GESTIONE_PRATICHE_PATH +
        "/legaliSuggeriti/" +
        idFascicolo
    );
  }
  getContrtto(idContratto): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + "/rs/tab/gp/contrattolegale/" + idContratto
    );
  }

  getDocumentazione(tipoPratica: string, idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        `/rs/ops/gp/${tipoPratica}/fasc/ordinario/${idFascicolo}/documentazione`
    );
  }

  getTariffeLegale(id: string): Observable<TariffaLegale[]> {
    return this.http
      .get<{ tariffe: TariffaLegale[] }>(
        ServicePathsSettings.DOMINIO + "/rs/src/gp/tariffe/" + id
      )
      .pipe(pluck("tariffe"));
  }

  eliminaTariffaLegaleIncaricato(id: string): Observable<boolean> {
    return this.http.delete<boolean>(
      ServicePathsSettings.DOMINIO + "/rs/ops/gp/tariffa/legaleincaricato/" + id
    );
  }

  modificaTariffaLegaleIncaricato(req: {
    tariffa: TariffaLegaleIncaricato;
  }): Observable<TariffaLegaleIncaricato> {
    return this.http
      .put<{ tariffa: TariffaLegaleIncaricato }>(
        ServicePathsSettings.DOMINIO + "/rs/ops/gp/tariffa/legaleincaricato",
        req
      )
      .pipe(pluck("tariffa"));
  }

  generaDelibera(idEsito: string): Observable<any> {
    return this.http
      .get(
        ServicePathsSettings.DOMINIO +
          ServicePathsSettings.GENERA_DELIBERA +
          idEsito,
        {
          responseType: "arraybuffer",
          observe: "response",
          withCredentials: true,
        }
      )
      .pipe(this.download_operator);
  }

  generaLetteraRicorrente(idEsito: string): Observable<any> {
    return this.http
      .get(
        ServicePathsSettings.DOMINIO +
          ServicePathsSettings.GENERA_LETTERA_RICCORRENTE +
          idEsito,
        {
          responseType: "arraybuffer",
          observe: "response",
          withCredentials: true,
        }
      )
      .pipe(this.download_operator);
  }

  eliminaConfigurazione(pratica, fascicolo, grado): Observable<boolean> {
    if (grado) {
      return this.http.delete<boolean>(
        ServicePathsSettings.DOMINIO +
          ServicePathsSettings.URL_DELETE_CONFIGURAZIONE_GRADO.replace(
            "{idPratica}",
            pratica
          )
            .replace("{idFascicolo}", fascicolo)
            .replace("{idGrado}", grado)
      );
    } else {
      return this.http.delete<boolean>(
        ServicePathsSettings.DOMINIO +
          ServicePathsSettings.URL_DELETE_CONFIGURAZIONE.replace(
            "{idPratica}",
            pratica
          ).replace("{idFascicolo}", fascicolo)
      );
    }
  }

  modificaTripletta(tripletta): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + "/rs/scadenzario/update/configurazione",
      tripletta
    );
  }
  eliminaLiquidati(
    urlEliminaLiquidati: string,
    idFascicolo: string,
    idSezioneEconomica: string,
    listLiquidati: Liquidato[]
  ): Observable<any> {
    let response = this.http.post(
      ServicePathsSettings.DOMINIO +
        urlEliminaLiquidati
          .replace("{idSezione}", idSezioneEconomica)
          .replace("{idFascicolo}", idFascicolo),
      listLiquidati
    );
    return response;
  }

  addDannoBiologico(tipoPraticaEndpoint: string, request: DannoBiologico, idSezione: string, idFascicolo: string, genericFascicolo: string): Observable<any> {
    let url = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + `/${tipoPraticaEndpoint}/fasc/${genericFascicolo}/${idFascicolo}/sez/economici/${idSezione}/dannobiologico`;
    let response = this.http.post(url, request);
    return response;
  }

  modificaDannoBiologico(tipoPraticaEndpoint: string, request: DannoBiologico, idSezione: string, idFascicolo: string, genericFascicolo: string): Observable<any> {
    let url = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + `/${tipoPraticaEndpoint}/fasc/${genericFascicolo}/sez/economici/${idSezione}/dannobiologico`;
    let response = this.http.put(url, request);
    return response;
  }

  inserisciLiquidati(url: string, idFascicolo:string, idSezioneEconomica: string, liquidati: Liquidato[]): Observable<any>{
    return this.http.post(ServicePathsSettings.DOMINIO +
      url.replace('{idSezione}', idSezioneEconomica).replace('{idFascicolo}', idFascicolo), liquidati)
  }

  deleteLiquidati(url, idFascicolo, idSezioneEconomica, liquidati): Observable<any> {
    return this.http.put(ServicePathsSettings.DOMINIO +
      url.replace('{idSezione}', idSezioneEconomica).replace('{idFascicolo}', idFascicolo), liquidati)
  }
  modificaLiquidati(url, idFascicolo, idSezioneEconomica, liquidati): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO +
      url.replace('{idSezione}', idSezioneEconomica).replace('{idFascicolo}', idFascicolo), liquidati)
  }

  addDescrizioneSpesa(descrizioneSpesa: string, tag: string): Observable<any>{
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_PATH_TIPOLOGICA_ADD.replace('{tipologicaTag}', tag), descrizioneSpesa)
  }

  addSpesaGiudizio(spesaGiudizio: SpeseDiGiudizio, url: string): Observable<any>{
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.GESTIONE_PRATICHE_BASE_PATH + '/' +url, spesaGiudizio)
  }

  updateSpeseGiudizio(spesaGiudizio: SpeseDiGiudizio, url): Observable<any>{
    return this.http.put(ServicePathsSettings.DOMINIO + ServicePathsSettings.GESTIONE_PRATICHE_BASE_PATH + '/' + url, spesaGiudizio)
  }

  deleteSpesaGiudizio(spesaGiudizio: SpeseDiGiudizio, url): Observable<any>{
    return this.http.delete(ServicePathsSettings.DOMINIO + ServicePathsSettings.GESTIONE_PRATICHE_BASE_PATH + '/' + url + '/'  + spesaGiudizio.id)
  }

  getBancheDati(url: string, request):Observable<any>{
    return this.http.post(ServicePathsSettings.DOMINIO_API_GATEWAY + url, request);
  }

  getRequestSole24Ore(tipoPratica, tipoFascicolo, idFascicolo): Observable<any>{
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + tipoPratica + '/fasc/' + tipoFascicolo + '/sole24ore/' + idFascicolo)
  }

  getTipologicheSole24Ore(nodo: string, tipoPratica: string, tipoFascicolo: string): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + '/rs/ops/gp/' + tipoPratica + '/fasc/' + tipoFascicolo + '/sole24ore/data/' + nodo);
  }

  sole24OreSearch(tipoPratica, tipoFascicolo, idFascicolo, request): Observable<any>{
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + tipoPratica + '/fasc/' + tipoFascicolo + '/sole24ore/' + idFascicolo + '/search', request)
  }

  importDocSole24Ore(tipoPratica: string, tipoFascicolo: string, idFascicolo: string, idDoc: string){
    return this.http.get(ServicePathsSettings.DOMINIO + '/rs/ops/gp/' + tipoPratica + '/fasc/' + tipoFascicolo + '/sole24ore/' + idFascicolo +  '/import/' + idDoc);
  }

  getDocumentoHtmlSole24Ore(tipoPratica, tipoFascicolo, idDoc): Observable<any>{
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/' + tipoPratica + '/fasc/' + tipoFascicolo + '/sole24ore/documento/' + idDoc);
  }

  checkVisibilityFascicolo(idPratica: string, idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_VISIBILITY +
      "/pratica/" + idPratica + "/fascicolo/" + idFascicolo
    );
  }

  checkIsDocumentazione(idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_DOCUMENTAZIONE_ALLEGATA + idFascicolo
    );
  }

  checkVisibilityPratica(idPratica: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_VISIBILITY +
      "/pratica/" + idPratica
    );
  }

  checkFascicoloExists(idFascicolo: string): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH + "/check/fascicolo/" + idFascicolo
    );
  }

  checkPraticaExists(idPratica: string): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH + "/check/pratica/" + idPratica
    );
  }

  // EXPORT

  // getAllRequestsDataExport(): Observable<any> {
  //   return this.http.get(ServicePathsSettings.URL_DATAEXPORT);
  // }

  getAllRequestsDataExport(obj: any, params: Map<string, string>, pagable: Pagable): Observable<PaginatedResponse<DataExport>> {
    let queryParams = new HttpParams({});
    if (obj) {
      queryParams = new HttpParams({ fromObject: obj });
    } else if (params) {
      params.forEach((value: string, key: string) => {
        queryParams = queryParams.append(key, value);
      });
    }
    if (pagable) {
      queryParams = queryParams.append('page', '' + pagable.page);
      queryParams = queryParams.append('size', '' + pagable.size);
    }

    const requestOptions = { params: queryParams };

    return this.http.get<PaginatedResponse<DataExport>>(ServicePathsSettings.URL_DATAEXPORT, requestOptions);
  }

  downloadDataExportById(id: string): Observable<any> {
    let response = this.http.get(ServicePathsSettings.URL_DATAEXPORT +
      ServicePathsSettings.URL_DATAEXPORT_DOWNLOAD + "/" + id, {
        observe: 'response',
        responseType: 'blob' as 'json'
      });
    return response;
  }

  deleteRequestDataExportById(id: string): Observable<any> {
    return this.http.delete(ServicePathsSettings.URL_DATAEXPORT +
      ServicePathsSettings.URL_DATAEXPORT_DELETE + "/" + id);
  }

  createRequestDataExport(data: DataExport): Observable<any> {
    return this.http.post(ServicePathsSettings.URL_DATAEXPORT +
      ServicePathsSettings.URL_DATAEXPORT_CREATE, data);
  }

  checkDownloadStatus(idFascicolo: string): Observable<any> {
    const url = `${ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH}/downloadRequest/${idFascicolo}`;
    return this.http.get<string>(url);
  }

  requestDownload(idFascicolo: any): Observable<any> {
    const url = `${ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH}/downloadRequest`;
    return this.http.post(url, { idFascicolo });
  }

  exportRicerca(searchRequest): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.SEARCH_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/pratiche/stampa', searchRequest, {responseType: 'blob' as 'json'})
  }

  getUtentiAssegnatari(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_UTENTI_ASSEGNATARI
    );
  }

  getNotifichePaginate(params: any): Observable<{ items: NotificaAttivita[], totalItems: number }> {
    let httpParams = new HttpParams()
      .set('page', params.page ?? 0)
      .set('size', params.size ?? 10)
      .set('order', params.order ?? '');

    if (params.assegnatario) {
      httpParams = httpParams.set('assegnatario', params.assegnatario);
    }
    if (params.testoNotifica) {
      httpParams = httpParams.set('testoNotifica', params.testoNotifica);
    }
    if (params.dataNotificaDa) {
      httpParams = httpParams.set('dataInizioNotifica', params.dataNotificaDa);
    }
    if (params.dataNotificaA) {
      httpParams = httpParams.set('dataFineNotifica', params.dataNotificaA);
    }
    if (params.mittente) {
      httpParams = httpParams.set('mittente', params.mittente);
    }

    return this.http.get<{ items: NotificaAttivita[], totalItems: number }>(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GET_NOTIFICHE_PAGINATE,
      { params: httpParams }
    );
  }

  getPdvPaginate(params: any): Observable<{ items: PacchettoVersamento[], totalItems: number }> {
    let httpParams = new HttpParams()
      .set('page', params.page ?? 0)
      .set('size', params.size ?? 10)
      .set('order', params.order ?? '');

      if (params.posizioneFascicolo) {
        httpParams = httpParams.set('posizioneFascicolo', params.posizioneFascicolo);
      }
      if (params.numeroProtocollo) {
        httpParams = httpParams.set('numeroProtocollo', params.numeroProtocollo);
      }
      if (params.dataProtocolloDa) {
        httpParams = httpParams.set('dataProtocolloDa', params.dataProtocolloDa);
      }
      if (params.dataProtocolloA) {
        httpParams = httpParams.set('dataProtocolloA', params.dataProtocolloA);
      }
      if (params.dataRichiestaDa) {
        httpParams = httpParams.set('dataRichiestaDa', params.dataRichiestaDa);
      }
      if (params.dataRichiestaA) {
        httpParams = httpParams.set('dataRichiestaA', params.dataRichiestaA);
      }
      if (params.stato) {
        httpParams = httpParams.set('stato', params.stato);
      }

    return this.http.get<{ items: PacchettoVersamento[], totalItems: number }>(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GET_PACCHETTI_PAGINATI,
      { params: httpParams }
    );
  }

  estraiContenutoArchivio(refDocumentale): Observable<FileData[]> {
    let url = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + "/files" ;
    return this.http.get<FileData[]>(
      url + "/" + refDocumentale,
      {
        context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
      }
    );
  }

  generaDocumento(baseUrl: string, id): Observable<any> {
    return this.http.get(
      `${baseUrl}/conservazione/${id}/pdv`,
      {
        responseType: "blob",
        observe: "response",
      }
    ).pipe(this.download_operator);
  }

  fetchDocumentazioneFormata(idFascicolo: string): Observable<{documentiFascicolo: DocumentoAllegato[]}> {
    const url = `${ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH}/fascicolo/${idFascicolo}/documentazione-formata`;
    return this.http.get<{documentiFascicolo: DocumentoAllegato[]}>(url);
  }

  forzaInvio(idRichiesta: string): Observable<any> {
    return this.http.post(ServicePathsSettings.DOMINIO + ServicePathsSettings.RS_PATH + `/ms/conservazione/forzaConservazione/${idRichiesta}`, {});
  }
}
